import {
  ChangeDetectorRef,
  Directive,
  effect,
  Input,
  signal,
  TemplateRef,
  untracked,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { UserRole } from '@app/features/users/user.model';
import { IAuthenticatedUserService } from '@app/shared/auth/authenticated-user-service/authenticated-user-service';
import { AUTHENTICATED_USER_SERVICE } from '@app/shared/auth/authenticated-user-service/authenticated-user-service.token';
import { RolesRevision } from './roles-revision';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class HasRoleDirective {
  private readonly authenticatedUserService = inject(
    AUTHENTICATED_USER_SERVICE,
  ) as IAuthenticatedUserService;

  private readonly cdr = inject(ChangeDetectorRef);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly rolesRevision = inject(RolesRevision);
  private readonly roles = signal<UserRole[]>([]);
  private hasView = false;

  constructor() {
    // Relu quand les rôles demandés changent, et quand le jeton a été renouvelé parce que les
    // droits de l'utilisateur ont pu changer (dode:profil).
    effect(() => {
      const roles = this.roles();
      this.rolesRevision.value();
      untracked(() => this.render(roles));
    });
  }

  @Input()
  set appHasRole(roles: UserRole[]) {
    this.roles.set(roles);
    this.render(roles);
  }

  private render(roles: UserRole[]): void {
    const hasRole = roles?.length ? this.authenticatedUserService.hasAnyRole(roles) : false;
    if (hasRole && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }

    if (!hasRole && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
    this.cdr.markForCheck();
  }
}
